/** @generated */
/**
 * --- DO NOT MODIFY THIS FILE ---------------------------------------------------------------------
 *
 * This file is automatically generated using generator/icons/generate-icons.js. If you wish to
 * change the icon, update the new icon to spec/icons under the correct name and then run:
 *
 *     npm run generate:icons
 *
 * -------------------------------------------------------------------------------------------------
 */

/**
 * The "PlusSmall" icon.
 *
 * @param { { className?: string, height?: number, width?: number,  stroke?: string,   fill?: string,  } }
 */
export default function PlusSmallIcon({
  className = '',
  height = 19,
  width = 19,
  stroke = '#5351CE',
  fill = 'none',
} = {}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.5 9.5H15.5" stroke={stroke} strokeLinecap="round" />
      <path d="M9.5 15.5L9.5 3.5" stroke={stroke} strokeLinecap="round" />
    </svg>
  );
}
